import { Box, Image, ImageProps, SxProps, Theme } from "@outschool/backpack";
import { Container } from "@outschool/ui-legacy-component-library";
import { responsive } from "@outschool/ui-utils";
import React from "react";

type TestimonialProps = {
  image: string;
  name: string;
  text: string;
  whereabouts?: string;
  containerSx?: SxProps;
  renderImage?: (props: ImageProps) => React.ReactElement;
};

export default function Testimonial({
  text,
  name,
  whereabouts,
  image,
  containerSx = {},
  renderImage,
}: TestimonialProps) {
  return (
    <Container
      size="small"
      sx={{
        display: "flex",
        alignItems: responsive({ default: "start", medium: "center" }),
        gap: responsive({ default: "medium", medium: "xlarge" }),
        paddingY: "xlarge",
        ...containerSx,
      }}
    >
      {renderImage ? (
        renderImage({
          src: image,
          alt: name,
        })
      ) : (
        <Image
          sx={(theme: Theme) => ({
            width: "64px",
            height: "64px",
            [theme.breakpoints.up("md")]: {
              width: "230px",
              height: "230px",
            },
            flexShrink: 0,
            borderRadius: "100%",
            backgroundSize: "cover",
            backgroundColor: "#f1f1f1",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            overflow: "hidden",
          })}
          src={image}
          alt={name}
        />
      )}
      <Box
        flex
        sx={{
          flexDirection: "column",
          gap: "0.5em",
        }}
      >
        <Box>“{text}”</Box>
        <Box
          sx={{
            fontWeight: "fontWeightBold",
          }}
        >
          —{name}
          {!!whereabouts && `, ${whereabouts}`}
        </Box>
      </Box>
    </Container>
  );
}
